// frontend/src/components/book/atelier/store/createStore.js
//
// Petit conteneur autour d'un reducer pur : getState / dispatch / subscribe.
// Pourquoi pas un simple useReducer : le moteur de sauvegarde (hors React)
// doit lire l'etat A JOUR juste apres un dispatch. Avec useReducer, l'etat
// n'est visible qu'au rendu suivant — le moteur verrait encore la page comme
// "sale" apres l'avoir ecrite et la re-ecrirait en boucle. Ici dispatch
// reduit de maniere synchrone ; React s'y abonne via useSyncExternalStore
// (voir BookStoreProvider.js). Aucune dependance ajoutee.

export function createStore(reducer, initialState) {
  let state = initialState;
  const listeners = new Set();

  return {
    getState: () => state,
    dispatch: (action) => {
      const next = reducer(state, action);
      if (next === state) return;
      state = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    }
  };
}
